const FeedbackPositiveSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none">
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13.85 3.65c.2.201.2.527 0 .728L6.306 11.92c-.201.2-.527.2-.728 0L2.151 8.492a.514.514 0 0 1 .727-.727l3.065 3.065 7.18-7.18c.2-.2.526-.2.726 0Z"
      clipRule="evenodd"
    />
  </svg>
)
export { FeedbackPositiveSvg }
